import {
  AppointmentsType,
  ArchiveSecureMessageParams,
  AuthType,
  CheckoutParameters,
  ExecuteBalancePaymentParams,
  ExecuteMembershipBankPaymentParams,
  GetClHairParams,
  GetSecureMessagesParams,
  MarkSecureMessageUnreadParams,
  RefCodeSubmitType,
  ReplySecureMessageParams,
  UpdateClDetailsParams
} from 'types';

import { get, post } from './axios';

const URLS = {
  getClDetails: 'get-cl-details',
  updateClDetails: 'update-cl-details',
  getClUpcomingSvc: 'get-cl-upcoming-svc',
  getClPastSvc: 'get-cl-past-svc',
  getClRecentSvc: 'get-cl-recent-svc',
  clUpdatePass: 'cl-update-pass',
  getClAccounts: 'get-cl-accounts',
  checkPass: 'cl-check-pass',
  uploadClPhoto: 'upload-cl-photo',
  getClAppointments: 'get-cl-appts',
  getClGiftCards: 'get-cl-gcards',
  addClGiftCard: 'cl-reg-giftcard',
  getClRequiredForms: 'cl-req-form',
  getClPastForms: 'cl-signed-form',
  getActiveMemberships: 'memberships_list',
  getActiveMembershipDetails: 'memberships_details',
  updateMembershipStatus: 'memberships_update-status',
  updateMembershipPayment: 'memberships_update-pymt-method',
  membershipsExecPayment: 'memberships_exec-payment',
  executeBalancePayment: 'execute-balance-payment',
  executeMembershipBankPayment: 'execute-membership-bank-payment',
  getSiteAlerts: 'site-alerts',
  getReferralPrefs: 'get-referral-prefs',
  submitReferral: 'submit-referral',
  getMembershipList: 'get-memberships',
  getMembershipDetails: 'get-membership-details',
  cartCompleteCheckout: 'cart_complete-checkout',
  cancelAppointment: 'appt-cancel',
  checkSyncStatus: 'sys-prefs',
  getSysModules: 'sys-modules',
  getSecMessages: 'get-sec-messages',
  getSecMessageConversation: 'get-sec-message-conversation',
  replySecMessage: 'reply-sec-message',
  unreadSecMessage: 'unread-sec-message',
  archiveSecMessage: 'archive-sec-message',
  getClHair: 'get-cl-hair'
};

const clientApi = {
  uploadClPhoto: (file: File) =>
    post(
      URLS.uploadClPhoto,
      { file },
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ),
  getOnLoginClDetails: (params: AuthType) => get(URLS.getClDetails, params),
  getClDetails: () => get(URLS.getClDetails),
  updateClDetails: (params: UpdateClDetailsParams) =>
    post(URLS.updateClDetails, params),
  checkPass: (pass: string) => post(URLS.checkPass, { pass }),
  updatePass: (pass: string, params = {}) =>
    post(URLS.clUpdatePass, { pass, ...params }),

  getUpcomingServices: () => get(URLS.getClUpcomingSvc),
  getPastServices: (number: number) =>
    get(URLS.getClPastSvc, { items: number, order_by: 1 }),
  getRecentServices: (params: {
    items?: number;
    svc_id?: number;
    cat_id?: number;
  }) => get(URLS.getClRecentSvc, params),
  getClAccounts: () => get(URLS.getClAccounts),
  getClAppointments: (itemType: AppointmentsType, number: number = 10) =>
    get(URLS.getClAppointments, { type: itemType, number }),
  getClGiftCards: () => get(URLS.getClGiftCards),
  getClRequiredForms: () => get(URLS.getClRequiredForms),
  getClPastForms: () => get(URLS.getClPastForms),
  getActiveMemberships: () => get(URLS.getActiveMemberships),
  getActiveMembershipDetails: (id: string) =>
    get(URLS.getActiveMembershipDetails, { id }),
  updateMembershipStatus: (id: string) =>
    get(URLS.updateMembershipStatus, { id, status: 'active' }),
  updateMembershipPayment: (id: string, pymtId: number) =>
    get(URLS.updateMembershipPayment, {
      id,
      cl_pymt_id: pymtId,
      type: 'primary'
    }),
  getSiteAlerts: () => get(URLS.getSiteAlerts),
  addClGiftCard: (serial: string) => get(URLS.addClGiftCard, { serial }),
  getReferralPrefs: () => get(URLS.getReferralPrefs),
  submitReferral: (params: RefCodeSubmitType) =>
    post(URLS.submitReferral, params),
  membershipsExecPayment: (id: number) =>
    post(URLS.membershipsExecPayment, { id }),
  executeBalancePayment: (params: ExecuteBalancePaymentParams) =>
    post(URLS.executeBalancePayment, params),
  executeMembershipBankPayment: (params: ExecuteMembershipBankPaymentParams) =>
    post(URLS.executeMembershipBankPayment, params),
  getMembershipList: (locid: number) => get(URLS.getMembershipList, { locid }),
  getMembershipDetails: (params: { id: number; locid: number }) =>
    get(URLS.getMembershipDetails, params),
  cartCompleteCheckout: (params: CheckoutParameters) =>
    post(URLS.cartCompleteCheckout, { ...params }),
  cancelAppointment: (confirmationId: number) =>
    get(URLS.cancelAppointment, { appt_id: confirmationId }),
  checkSyncStatus: () => get(URLS.checkSyncStatus),
  getSysModules: () => get(URLS.getSysModules),
  getSecMessages: (params: GetSecureMessagesParams = {}) =>
    get(URLS.getSecMessages, params),
  getSecMessageConversation: (msg_id: number) =>
    get(URLS.getSecMessageConversation, { msg_id }),
  replySecMessage: (params: ReplySecureMessageParams) =>
    post(URLS.replySecMessage, {}, { params }),
  unreadSecMessage: (params: MarkSecureMessageUnreadParams) =>
    post(URLS.unreadSecMessage, {}, { params }),
  archiveSecMessage: (params: ArchiveSecureMessageParams) =>
    post(URLS.archiveSecMessage, {}, { params }),
  getClHair: (params: GetClHairParams) => get(URLS.getClHair, params)
};

export default clientApi;
